import useGraphSign from 'hooks/useGraphSign';

import { createContext } from 'react';

type DrawsProviderProps = { children: React.ReactNode };

export const DrawsContext = createContext<any>({});

export default function DrawsProvider({ children }: DrawsProviderProps) {
    const {
        fillEvidences,
        evidences,
        draw,
        draws,
        setDraw,
        setDraws,
        resetDraw,
        drawSignature,
        setSignature,
        pages,
        actualPage,
        pagesRef,
        signatureRef,
        signature,
        removeDraw,
        drawsWithSameSigner,
        removeAllDrawsWhithSameSigner
    } = useGraphSign();

    return (
        <DrawsContext.Provider
            value={{
                fillEvidences,
                evidences,
                draw,
                draws,
                setDraw,
                setDraws,
                resetDraw,
                drawSignature,
                signature,
                setSignature,
                actualPage,
                pages,
                pagesRef,
                signatureRef,
                removeDraw,
                drawsWithSameSigner,
                removeAllDrawsWhithSameSigner
            }}
        >
            {children}
        </DrawsContext.Provider>
    );
}
